import { render, staticRenderFns } from "./EnrolledDetail.vue?vue&type=template&id=58b70ee4&scoped=true"
import script from "./EnrolledDetail.vue?vue&type=script&lang=js"
export * from "./EnrolledDetail.vue?vue&type=script&lang=js"
import style0 from "./EnrolledDetail.vue?vue&type=style&index=0&id=58b70ee4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b70ee4",
  null
  
)

export default component.exports